export const InitiativeSyncJiraIssueName = 'initiativesSyncJiraIssue';
